import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { strict as t } from "../core/jsonMap.js";
import { beforeLocaleChange as o, getLocale as e } from "./locale.js";

var r = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
},
    n = {
  year: "numeric",
  month: "long",
  day: "numeric"
},
    a = {
  year: "numeric",
  month: "short",
  day: "numeric"
},
    h = {
  year: "numeric",
  month: "long",
  weekday: "long",
  day: "numeric"
},
    m = {
  hour: "numeric",
  minute: "numeric"
},
    i = _objectSpread(_objectSpread({}, m), {}, {
  second: "numeric"
}),
    s = {
  "short-date": r,
  "short-date-short-time": _objectSpread(_objectSpread({}, r), m),
  "short-date-short-time-24": _objectSpread(_objectSpread(_objectSpread({}, r), m), {}, {
    hour12: !1
  }),
  "short-date-long-time": _objectSpread(_objectSpread({}, r), i),
  "short-date-long-time-24": _objectSpread(_objectSpread(_objectSpread({}, r), i), {}, {
    hour12: !1
  }),
  "short-date-le": r,
  "short-date-le-short-time": _objectSpread(_objectSpread({}, r), m),
  "short-date-le-short-time-24": _objectSpread(_objectSpread(_objectSpread({}, r), m), {}, {
    hour12: !1
  }),
  "short-date-le-long-time": _objectSpread(_objectSpread({}, r), i),
  "short-date-le-long-time-24": _objectSpread(_objectSpread(_objectSpread({}, r), i), {}, {
    hour12: !1
  }),
  "long-month-day-year": n,
  "long-month-day-year-short-time": _objectSpread(_objectSpread({}, n), m),
  "long-month-day-year-short-time-24": _objectSpread(_objectSpread(_objectSpread({}, n), m), {}, {
    hour12: !1
  }),
  "long-month-day-year-long-time": _objectSpread(_objectSpread({}, n), i),
  "long-month-day-year-long-time-24": _objectSpread(_objectSpread(_objectSpread({}, n), i), {}, {
    hour12: !1
  }),
  "day-short-month-year": a,
  "day-short-month-year-short-time": _objectSpread(_objectSpread({}, a), m),
  "day-short-month-year-short-time-24": _objectSpread(_objectSpread(_objectSpread({}, a), m), {}, {
    hour12: !1
  }),
  "day-short-month-year-long-time": _objectSpread(_objectSpread({}, a), i),
  "day-short-month-year-long-time-24": _objectSpread(_objectSpread(_objectSpread({}, a), i), {}, {
    hour12: !1
  }),
  "long-date": h,
  "long-date-short-time": _objectSpread(_objectSpread({}, h), m),
  "long-date-short-time-24": _objectSpread(_objectSpread(_objectSpread({}, h), m), {}, {
    hour12: !1
  }),
  "long-date-long-time": _objectSpread(_objectSpread({}, h), i),
  "long-date-long-time-24": _objectSpread(_objectSpread(_objectSpread({}, h), i), {}, {
    hour12: !1
  }),
  "long-month-year": {
    month: "long",
    year: "numeric"
  },
  "short-month-year": {
    month: "short",
    year: "numeric"
  },
  year: {
    year: "numeric"
  },
  "short-time": m,
  "long-time": i
},
    l = t()({
  shortDate: "short-date",
  shortDateShortTime: "short-date-short-time",
  shortDateShortTime24: "short-date-short-time-24",
  shortDateLongTime: "short-date-long-time",
  shortDateLongTime24: "short-date-long-time-24",
  shortDateLE: "short-date-le",
  shortDateLEShortTime: "short-date-le-short-time",
  shortDateLEShortTime24: "short-date-le-short-time-24",
  shortDateLELongTime: "short-date-le-long-time",
  shortDateLELongTime24: "short-date-le-long-time-24",
  longMonthDayYear: "long-month-day-year",
  longMonthDayYearShortTime: "long-month-day-year-short-time",
  longMonthDayYearShortTime24: "long-month-day-year-short-time-24",
  longMonthDayYearLongTime: "long-month-day-year-long-time",
  longMonthDayYearLongTime24: "long-month-day-year-long-time-24",
  dayShortMonthYear: "day-short-month-year",
  dayShortMonthYearShortTime: "day-short-month-year-short-time",
  dayShortMonthYearShortTime24: "day-short-month-year-short-time-24",
  dayShortMonthYearLongTime: "day-short-month-year-long-time",
  dayShortMonthYearLongTime24: "day-short-month-year-long-time-24",
  longDate: "long-date",
  longDateShortTime: "long-date-short-time",
  longDateShortTime24: "long-date-short-time-24",
  longDateLongTime: "long-date-long-time",
  longDateLongTime24: "long-date-long-time-24",
  longMonthYear: "long-month-year",
  shortMonthYear: "short-month-year",
  year: "year"
}),
    g = l.apiValues,
    y = l.toJSON.bind(l),
    d = l.fromJSON.bind(l),
    u = {
  ar: "ar-u-nu-latn-ca-gregory"
};

var c = new WeakMap(),
    D = s["short-date-short-time"];

function T(t) {
  var o = t || D;

  if (!c.has(o)) {
    var _t = e(),
        _r = u[e()] || _t;

    c.set(o, new Intl.DateTimeFormat(_r, o));
  }

  return c.get(o);
}

function S(t) {
  return s[t] || null;
}

function L(t, o) {
  return T(o).format(t);
}

o(function () {
  c = new WeakMap(), D = s["short-date-short-time"];
});
export { S as convertDateFormatToIntlOptions, g as dateFormats, l as dictionary, L as formatDate, d as fromJSON, T as getDateTimeFormatter, y as toJSON };